import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  cashBooks: [],
  tempCashBooks: [],
  isLoading: false,
  pagination: {
    total: 0,
    page: 1,
    pages: 1,
  },
};

const cashBookSlice = createSlice({
  name: "cashBook",
  initialState,
  reducers: {
    setCashBooks(state, action) {
      state.cashBooks = action.payload;
      state.isLoading = false;
    },
    setTempCashBooks(state, action) {
      state.tempCashBooks = action.payload;
    },
    setCashBooksPagination(state, action) {
      state.pagination = action.payload;
    },
    // addExpense(state, action) {
    //   state.expenses.push(action.payload);
    //   state.tempExpenses.push(action.payload);
    // },
    // updateExpense(state, action) {
    //   const { index, expense } = action.payload;
    //   console.log(index, expense);
    //   state.expenses?.splice(index, 1, expense);
    //   state.tempExpenses?.splice(index, 1, expense);
    // },
    // deleteExpense(state, action) {
    //   const { index } = action.payload;
    //   state.expenses.splice(index, 1);
    //   state.tempExpenses.splice(index, 1);
    // },
    setCashBookIsLoading(state, action) {
      state.isLoading = true;
    },
  },
});

export const {
  setCashBooks,
  setTempCashBooks,
  setCashBooksPagination,
  //   addExpense,
  //   updateExpense,
  //   deleteExpense,
  setCashBookIsLoading,
} = cashBookSlice.actions;
export default cashBookSlice.reducer;
